<template>
  <div class="card-report">
    <div class="report-text" v-html="text"></div>
    <button class="report-button" @click="$emit('buttonClicked')">
      <i class="yk-report"></i>
      <span>举报</span>
    </button>
  </div>
</template>
<script>
export default {
  name: 'CardReport',
  props: { text: String },
};
</script>
<style lang="scss" scoped>
.card-report {
  padding: 20px;
  border: 1px solid #eeeeee;
  border-radius: 6px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 50px 0;
}
.report-text {
  font-size: 14px;
  line-height: 24px;
  color: var(--text-color-6);
  flex: 1;
  width: 0;
  padding-right: 10px;
}
.report-button {
  font-size: 16px;
  line-height: 24px;
  color: var(--primary-color);
  i {
    margin-right: 5px;
    font-size: 18px;
  }
}
</style>
